import { ShareAltOutlined } from '@ant-design/icons'
import { detectedUserAgent } from '@/utils/detectedUserAgent'

export interface IPropsShareTrack {
    onTouchStart: () => void,
}
export const ShareTrack = ({ onTouchStart }: IPropsShareTrack) => {

    const isMovil = detectedUserAgent()
    if (isMovil) {
        return (
            <>
                <ShareAltOutlined style={{ userSelect: 'none' }} onTouchStart={onTouchStart} />
            </>
        )
    }
    return null
}
